<template>
  <v-layout wrap class="grey lighten-2">
    <v-flex xs4>
      <v-list subheader dense class="transparent">
        <v-subheader>Filters</v-subheader>

        <abf-filter-item
          v-if="UIFilterOptions.hotProspect"
          :active="CustomerPageFilters.bool.hotProspect"
          icon="fad fa-flame"
          @click="toggleFilter('bool.hotProspect')"
          >Hot prospect
        </abf-filter-item>

        <abf-filter-item
          :active="CustomerPageFilters.noEmail"
          icon="fad fa-envelope"
          @click="toggleFilter('noEmail', 'withEmail')"
        >No Email
        </abf-filter-item>

        <abf-filter-item
          :active="CustomerPageFilters.withEmail"
          icon="fad fa-envelope"
          @click="toggleFilter('withEmail', 'noEmail')"
        >With Email
        </abf-filter-item>

        <abf-filter-item
          :active="CustomerPageFilters.withPhone"
          icon="fad fa-phone"
          @click="toggleFilter('withPhone', 'noPhone')"
        >With Telephone
        </abf-filter-item>

        <abf-filter-item
          :active="CustomerPageFilters.noPhone"
          icon="fad fa-phone"
          @click="toggleFilter('noPhone', 'withPhone')"
        >No Telephone
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.bankDecline"
          :active="CustomerPageFilters.bool.bankDecline"
          icon="fad fa-university"
          @click="toggleFilter('bool.bankDecline')"
          >Bank decline
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.brokerReferral"
          :active="CustomerPageFilters.bool.brokerReferral"
          icon="fad fa-user-chart"
          @click="toggleFilter('bool.brokerReferral')"
          >Broker referral
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.toBeCalled"
          :active="CustomerPageFilters.bool.toBeCalled"
          icon="fad fa-phone-plus"
          @click="toggleFilter('bool.toBeCalled')"
          >To be called
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.hasEnquiryErrors"
          :active="CustomerPageFilters.bool.hasEnquiryQuote"
          icon="fad fa-envelope-open-text"
          @click="toggleFilter('bool.hasEnquiryQuote')"
          >Has enquiry quote
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.hasEnquiryErrors"
          :active="CustomerPageFilters.bool.hasEnquiryErrors"
          icon="fad fa-exclamation-triangle"
          @click="toggleFilter('bool.hasEnquiryErrors')"
          >Has enquiry errors
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.hasEnquiryErrors"
          :active="CustomerPageFilters.bool.hasEnquiryFeedback"
          icon="fad fa-person-sign"
          @click="toggleFilter('bool.hasEnquiryFeedback')"
          >Has enquiry feedback
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.eliteReferral"
          :active="CustomerPageFilters.eliteReferral"
          icon="fad fa-medal"
          @click="toggleFilter('eliteReferral')"
          >Referred (Elite)
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.referral"
          :active="CustomerPageFilters.referral"
          icon="fad fa-people-carry"
          @click="toggleFilter('referral', 'notReferral')"
          >Referred
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.notReferral"
          :active="CustomerPageFilters.notReferral"
          icon="fad fa-person-carry"
          @click="toggleFilter('notReferral', 'referral')"
          >Not referred
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.trustPilot"
          :active="CustomerPageFilters.bool.trustpilot"
          icon="fad fa-star"
          @click="toggleFilter('bool.trustpilot')"
          >TrustPilot
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.trustpilotInvitationSent"
          :active="CustomerPageFilters.bool.trustpilot_invitation_sent"
          icon="fad fa-star"
          @click="toggleFilter('bool.trustpilot_invitation_sent')"
          >TP invitation sent
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.financialsSent"
          :active="CustomerPageFilters.bool.financialsSent"
          icon="fad fa-envelope-open-dollar"
          @click="toggleFilter('bool.financialsSent')"
          >Financials sent
        </abf-filter-item>

        <abf-filter-item
          :active="CustomerPageFilters.autoSendEnquiries"
          icon="fad fa-shipping-fast"
          @click="toggleFilter('autoSendEnquiries', 'notAutoSendEnquiries')"
          >Auto send
        </abf-filter-item>


        <abf-filter-item
          :active="CustomerPageFilters.notAutoSendEnquiries"
          icon="fad fa-truck"
          @click="toggleFilter('notAutoSendEnquiries', 'autoSendEnquiries')"
        >Not auto send enquiries
        </abf-filter-item>



        <abf-filter-item
          v-if="UIFilterOptions.questionsComplete"
          :active="CustomerPageFilters.questionsComplete"
          @click="toggleFilter('questionsComplete', 'questionsIncomplete')"
        >
          <v-progress-circular
            :rotate="-90"
            :size="28"
            :width="2"
            :value="100"
            :color="CustomerPageFilters.questionsComplete ? 'accent' : 'grey'"
            slot="icon"
          >
            100
          </v-progress-circular>
          Questions complete
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.questionsIncomplete"
          :active="CustomerPageFilters.questionsIncomplete"
          @click="toggleFilter('questionsIncomplete', 'questionsComplete')"
        >
          <v-progress-circular
            :rotate="-90"
            :size="28"
            :width="2"
            :value="0"
            :color="CustomerPageFilters.questionsIncomplete ? 'accent' : 'grey'"
            slot="icon"
          >
            0
          </v-progress-circular>
          Questions incomplete
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.open"
          :active="CustomerPageFilters.open"
          icon="fad fa-door-open"
          @click="toggleFilter('open')"
          >Open
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.closed"
          :active="CustomerPageFilters.bool.closed"
          icon="fad fa-door-closed"
          @click="toggleFilter('bool.closed')"
          >Closed
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.noEnquiries"
          :active="CustomerPageFilters.noEnquiries"
          icon="fad fa-comment-alt-slash"
          @click="toggleFilter('noEnquiries')"
          >No enquiries
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.hasDocuments"
          :active="CustomerPageFilters.bool.hasDocuments"
          icon="fad fa-file-alt"
          @click="toggleFilter('bool.hasDocuments')"
          >Has documents
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.newsletterSignup"
          :active="CustomerPageFilters.newsletterSignup"
          icon="fab fa-mailchimp"
          @click="toggleFilter('newsletterSignup')"
          >Marketing opt-in
        </abf-filter-item>

        <abf-filter-item
          v-if="UIFilterOptions.softSearchConsent"
          :active="CustomerPageFilters.bool.softSearchConsent"
          icon="fad fa-thumbs-up"
          @click="toggleFilter('bool.softSearchConsent')"
          >Soft-search Consent
        </abf-filter-item>
      </v-list>
    </v-flex>
    <v-flex xs4>
      <v-list dense subheader class="transparent">
        <v-subheader>Enquiry Statuses</v-subheader>

        <abf-filter-item
          :active="CustomerPageFilters.enquiryStatuses.includes(status.id)"
          v-for="status in orderedStatuses"
          :key="status.id"
          @click="toggleEnquiryStatusFilter(status)"
        >
          <v-checkbox
            readonly
            :input-value="CustomerPageFilters.enquiryStatuses.includes(status.id)"
            slot="icon"
          ></v-checkbox>
          {{ status.name | titleCase }}
        </abf-filter-item>

        <abf-filter-item
          v-if="!UserHasRole('Property Broker')"
          :active="CustomerPageFilters.revolvingEnquiries"
          @click="toggleFilter('revolvingEnquiries')"
        >
          <v-checkbox readonly :input-value="CustomerPageFilters.revolvingEnquiries" slot="icon"></v-checkbox>
          Revolving
        </abf-filter-item>
      </v-list>
    </v-flex>
    <v-flex xs4>
      <v-list dense subheader class="transparent">
        <v-subheader>Owners</v-subheader>

        <abf-filter-item
          :active="CustomerPageFilters.owners.includes(owner.id)"
          v-for="owner in orderedOwners"
          :key="owner.id"
          @click="toggleOwnerFilter(owner)"
        >
          <v-avatar size="33" slot="icon" color="white">
            <abf-owner-avatar :user="owner"></abf-owner-avatar>
          </v-avatar>
          {{ owner.full_name }}
        </abf-filter-item>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import AbfFilterItem from '@/components/Abf/Filters/AbfFilterItem';
import AbfOwnerAvatar from '@/components/Abf/AbfOwnerAvatar';

export default {
  name: 'filters',
  components: { AbfFilterItem, AbfOwnerAvatar },
  computed: {
    ...mapGetters(['CustomerPageFilters', 'EnquiryStatuses', 'OwnersList', 'UserHasRole', 'UIFilterOptions']),
    orderedStatuses: function() {
      let statuses = _.orderBy(this.EnquiryStatuses, 'name');
      if (this.UserHasRole('Property Broker')) {
        statuses = _.filter(statuses, status => status.system_only === false);
      }
      return statuses;
    },
    orderedOwners: function() {
      let owners = _.orderBy(this.OwnersList, 'full_name');
      if (this.UserHasRole('Property Broker')) {
        owners = _.filter(owners, owner => owner.roles.includes('Property Broker'));
      }
      owners.push({
        id: null,
        full_name: 'Not Assigned',
        roles: []
      });
      return owners;
    }
  },
  methods: {
    ...mapActions([
      'getCustomerPage',
      'storeCustomerEnquiry',
      'toggleCustomerPageFilter',
      'removeEnquiryStatusFilter',
      'addEnquiryStatusFilter',
      'removeOwnerFilter',
      'addOwnerFilter',
      'getOwnersList'
    ]),
    getPage: _.debounce(function() {
      // this.loading = true
      this.getCustomerPage(false)
        .then(() => {
          // this.loading = false
        })
        .catch(error => {
          console.log(error);
        });
      // })
    }, 250),
    toggleFilter(filter, secondaryFilter) {
      console.log(filter + " and secondary is: " + secondaryFilter)
      if (typeof secondaryFilter !== 'undefined' && this.CustomerPageFilters[secondaryFilter]) {
        this.toggleCustomerPageFilter(secondaryFilter);
      }
      this.toggleCustomerPageFilter(filter).then(() => {
        this.getPage();
      });
    },
    toggleEnquiryStatusFilter(status) {
      if (this.CustomerPageFilters.enquiryStatuses.includes(status.id)) {
        this.removeEnquiryStatusFilter(status);
      } else {
        this.addEnquiryStatusFilter(status);
      }
      this.getPage();
    },
    toggleOwnerFilter(owner) {
      if (this.CustomerPageFilters.owners.includes(owner.id)) {
        this.removeOwnerFilter(owner);
      } else {
        this.addOwnerFilter(owner);
      }
      this.getPage();
    }
  },
  filters: {
    titleCase: function(string) {
      return _.words(string)
        .map(word => (word.length !== 3 ? _.capitalize(word) : word))
        .reduce((carry, word) => carry + ' ' + word, '');
    }
  },
  beforeMount() {
    if (this.OwnersList.length <= 1) {
      this.getOwnersList();
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}

::v-deep .input-group__details {
  display: none;
}
</style>
